import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { I18nModule, UrlModule } from "@spartacus/core";
import { PromotionsModule, MediaModule, ItemCounterModule, FormErrorsModule, IconModule, KeyboardFocusModule } from "@spartacus/storefront";
import { KbCartDetailsComponent } from "./kb-cart-details.component";
import { RouterModule } from "@angular/router";
import { CartSharedModule, CartCouponModule, CartValidationWarningsModule } from "@spartacus/cart/base/components";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { KbSaveCartDialogComponent } from './kb-save-cart-dialog/kb-save-cart-dialog.component';
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { DeleteCartConfirmationComponent } from './delete-cart-confirmation/delete-cart-confirmation.component';
import { CanNavigateCheckoutComponent } from "./can-navigate-checkout/can-navigate-checkout.component";

@NgModule({
   imports: [
      CartSharedModule,
      CommonModule,
      CartCouponModule,
      RouterModule,
      UrlModule,
      PromotionsModule,
      I18nModule,
      MediaModule,
      CartValidationWarningsModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatInputModule,
      MatFormFieldModule,
      FormsModule,
      MatCheckboxModule,
      ItemCounterModule,
      ReactiveFormsModule,
      FormErrorsModule,
      IconModule,
      KeyboardFocusModule,
      MatDialogModule,
      MatButtonModule,
      MatIconModule,
   ],
   providers: [
   ],
   declarations: [KbCartDetailsComponent, KbSaveCartDialogComponent, DeleteCartConfirmationComponent, CanNavigateCheckoutComponent]
})
export class KbCartDetailsModule {

}
